module.exports = __webpack_public_path__ + "img/Pelletsorten.630ff88.png";